const groupBy = (array, flag) => array.reduce((groups, item) => {
  const val = item[flag];
  const newGroups = groups;
  newGroups[val] = newGroups[val] || [];
  newGroups[val].push(item);
  return newGroups;
}, {});

const uniquify = (array, key) => array.reduce((acc, item) => {
  if (acc.find(a => a[key] === item[key])) {
    return acc;
  }
  return acc.push(item) && acc;
}, []);

const range = (start, end) => Array((end - start) + 1).fill().map((_, idx) => start + idx);

const arrayMove = (arr, fromIndex, toIndex) => {
  if (toIndex > arr.length) return arr;
  const newArray = [...arr];
  newArray.splice(toIndex, 0, newArray.splice(fromIndex, 1)[0]);
  return newArray;
};

function compareForSort(a, b, flag) {
  if (a[flag] < b[flag]) {
    return -1;
  }
  if (a[flag] > b[flag]) {
    return 1;
  }
  return 0;
}

export { groupBy, uniquify, range, arrayMove, compareForSort };



// WEBPACK FOOTER //
// ./src/helpers/array-helpers.js